var _defs, _ellipse, _ellipse2, _ellipse3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path, _ellipse4, _line13, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3ddee;}.cls-1,.cls-3,.cls-4{stroke:#0090b9;stroke-width:2px;}.cls-1,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#fff;}.cls-3,.cls-4{fill:none;}.cls-4{stroke-linecap:round;stroke-linejoin:round;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 49.21,
    cy: 67.63,
    rx: 36.5,
    ry: 35.21
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 49.08,
    cy: 67.84,
    rx: 32,
    ry: 30
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 49.21,
    cy: 67.63,
    rx: 31.55,
    ry: 30.44
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.21,
    y1: 37.19,
    x2: 49.21,
    y2: 42.86
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.43,
    y1: 41.27,
    x2: 36.37,
    y2: 46.18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.88,
    y1: 52.41,
    x2: 26.97,
    y2: 55.24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.54,
    y1: 52.41,
    x2: 71.45,
    y2: 55.24
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 64.99,
    y1: 41.27,
    x2: 62.05,
    y2: 46.18
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 17.65,
    y1: 67.63,
    x2: 23.53,
    y2: 67.63
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.88,
    y1: 82.84,
    x2: 26.97,
    y2: 80.01
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.43,
    y1: 93.99,
    x2: 36.37,
    y2: 89.07
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.21,
    y1: 98.06,
    x2: 49.21,
    y2: 92.39
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 64.99,
    y1: 93.99,
    x2: 62.05,
    y2: 89.07
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.54,
    y1: 82.84,
    x2: 71.45,
    y2: 80.01
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.76,
    y1: 67.63,
    x2: 74.89,
    y2: 67.63
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.59,66.06l0-18.7a1.58,1.58,0,0,1,1.61-1.55h0a1.59,1.59,0,0,1,1.61,1.56l0,18.67"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 49.21,
    cy: 68.44,
    rx: 2.94,
    ry: 2.84
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 42.69,
    y1: 28.69,
    x2: 56.85,
    y2: 28.66
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.9,32.42V29.05H41a1.34,1.34,0,0,1-1.33-1.35V18.94A1.34,1.34,0,0,1,41,17.6H57.4a1.34,1.34,0,0,1,1.33,1.34V27.7a1.34,1.34,0,0,1-1.33,1.35H55.52v3.37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.12,37.46l2.33-2.86a1,1,0,0,1,1.39-.15l5.29,4a.94.94,0,0,1,.17,1.35L75,42.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.fba4a2804c97caaec51e7c54dfa73ada.svg";
export { ForwardRef as ReactComponent };